export var SPLIT_IMAGE_SIZE_48 = 56;
export var SPLIT_IMAGE_SIZE_80 = 80;